import { Box, Text } from '@nimbus-ds/components';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';
import useAlertPromote from './useAlertPromote';
import GenericTaskList from '../GenericTaskList';

function AlertPromote() {
  const t = useTranslationDashboard();
  const { items, handleAction, handleSkip } = useAlertPromote();

  if (items.length === 0) {
    return null;
  }

  return (
    <Box display="flex" flexDirection="column" gap="4">
      <Text fontSize="highlight" color="neutral-textHigh">
        {t('promote.securityMeasuresTitle')}
      </Text>
      <GenericTaskList
        items={items}
        onAction={handleAction}
        onSkip={handleSkip}
        variant="recommendations"
        paddingVertical="2"
      />
    </Box>
  );
}

export default AlertPromote;
